var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"footer"},[_c('span',[_vm._v("Version 1.0 Copyright "),_c('strong',[_vm._v(" NAWE-MANAGER ")]),_vm._v(" ® 2023 ")])])}]

export { render, staticRenderFns }